import CallsTable from "./CallsTable";

export default CallsTable